import { useEffect, useState } from "react";
import { Image as ImageIcon } from "@phosphor-icons/react";
import api from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { btnGhost } from "./util";

const cache = {};

export function useFileUrl(fid) {
    const [url, setUrl] = useState(cache[fid] || null);
    useEffect(() => {
        if (!fid || cache[fid]) { return; }
        let live = true;
        api.get(`/invoices/files/${fid}`, { responseType: "blob" }).then(({ data }) => {
            cache[fid] = URL.createObjectURL(data);
            if (live) setUrl(cache[fid]);
        }).catch(() => {});
        return () => { live = false; };
    }, [fid]);
    return url;
}

function Page({ fid, n }) {
    const url = useFileUrl(fid);
    if (!url) return <div className="h-40 grid place-items-center text-xs text-neutral-400">Loading image…</div>;
    return (
        <div className="space-y-1">
            <a href={url} target="_blank" rel="noreferrer" className="text-xs underline text-neutral-600" data-testid={`invoice-image-open-tab-${n}`}>Open full size (pinch to zoom)</a>
            <img src={url} alt={`Invoice page ${n + 1}`} className="w-full h-auto border border-mist" data-testid={`invoice-image-${n}`} />
        </div>
    );
}

export function InvoiceImages({ fileIds, label = "Original Invoice", testid = "invoice-view-original" }) {
    const [open, setOpen] = useState(false);
    if (!fileIds?.length) return null;
    return (
        <>
            <button type="button" className={btnGhost} onClick={() => setOpen(true)} data-testid={testid}><ImageIcon size={14} /> {label}{fileIds.length > 1 ? ` (${fileIds.length})` : ""}</button>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto p-3 sm:p-6" data-testid="invoice-image-dialog">
                    <DialogHeader><DialogTitle>Original Invoice</DialogTitle></DialogHeader>
                    <div className="space-y-4">{fileIds.map((f, n) => <Page key={f} fid={f} n={n} />)}</div>
                </DialogContent>
            </Dialog>
        </>
    );
}

export function Thumb({ fid, onRemove }) {
    const url = useFileUrl(fid);
    return (
        <div className="relative w-20 h-24 border border-mist bg-cream/40 shrink-0" data-testid={`invoice-thumb-${fid}`}>
            {url && <img src={url} alt="Invoice" className="w-full h-full object-cover" />}
            {onRemove && <button type="button" onClick={onRemove} aria-label="Delete page" className="absolute -top-2 -right-2 w-7 h-7 grid place-items-center rounded-full bg-white border border-mist text-sm shadow-sm" data-testid={`invoice-thumb-remove-${fid}`}>×</button>}
        </div>
    );
}
